module.exports = __webpack_public_path__ + "static/media/Dollar_Coin.a8251427.svg";